// Helpers PCG : construction de l'arbre, recherche, formatage.
//
// LOT 1 — Step 1.7 : le dataset n'est plus statique. `PCG` et `PCG_INDEX`
// sont peuplés au démarrage de l'app par `hydrate(accounts)` (fetch API).
// Tous les composants qui importent `PCG_INDEX` / `PCG` doivent être rendus
// APRÈS le bootstrap (garanti par App.js qui bloque le rendu tant que le
// hydrate n'a pas eu lieu).

// Références mutables partagées — pas de re-exports défensifs, on mute
// directement le tableau et l'index in-place pour préserver les identifiants
// d'objet côté React (utile si un composant garde une ref).
export const PCG = [];
export const PCG_INDEX = {};

/**
 * Hydrate le module avec les fiches reçues de l'API `/api/accounts`.
 * Idempotent : peut être appelé plusieurs fois (utile pour un refresh).
 */
export function hydrate(accounts) {
  PCG.length = 0;
  Object.keys(PCG_INDEX).forEach((k) => delete PCG_INDEX[k]);
  const sorted = [...accounts].sort((a, b) => a.num.localeCompare(b.num));
  for (const a of sorted) {
    PCG.push(a);
    PCG_INDEX[a.num] = a;
  }
}

// Construit un arbre hiérarchique : classe -> sous-comptes (2 chiffres) -> ... -> feuilles
export function buildTree(accounts = PCG) {
  const tree = {};
  const sorted = [...accounts].sort((a, b) => a.num.localeCompare(b.num));
  for (const acc of sorted) {
    const classeId = acc.num[0];
    if (!tree[classeId]) tree[classeId] = { num: classeId, children: [] };
    insertAccount(tree[classeId], acc);
  }
  return tree;
}

function insertAccount(parent, acc) {
  for (const child of parent.children) {
    if (acc.num.startsWith(child.num) && acc.num !== child.num) {
      insertAccount(child, acc);
      return;
    }
  }
  parent.children.push({ ...acc, children: [] });
}

// Filtre : recherche par numéro, libellé ou usage
export function searchAccounts(query) {
  if (!query) return [];
  const q = query.trim().toLowerCase();
  return PCG.filter(
    (a) =>
      a.num.startsWith(q) ||
      a.lib.toLowerCase().includes(q) ||
      (a.usage && a.usage.toLowerCase().includes(q))
  ).slice(0, 50);
}

// Format chiffre en euros (FR)
export function formatEUR(n) {
  if (n === 0 || n == null) return "";
  return new Intl.NumberFormat("fr-FR", {
    style: "currency",
    currency: "EUR",
    minimumFractionDigits: 2,
  }).format(n);
}

// Couleur du badge selon nature
export const NATURE_LABELS = {
  actif: { label: "Actif", color: "bg-amber-100 text-amber-900 border-amber-600" },
  passif: { label: "Passif", color: "bg-blue-100 text-blue-900 border-blue-600" },
  charge: { label: "Charge", color: "bg-orange-100 text-orange-900 border-orange-600" },
  produit: { label: "Produit", color: "bg-lime-100 text-lime-900 border-lime-600" },
  mixte: { label: "Mixte", color: "bg-slate-100 text-slate-900 border-slate-600" },
};

export const SENS_LABELS = {
  D: { label: "Débiteur", color: "bg-emerald-50 text-emerald-800 border-emerald-600" },
  C: { label: "Créditeur", color: "bg-rose-50 text-rose-800 border-rose-600" },
  M: { label: "Mixte (D ou C)", color: "bg-slate-50 text-slate-800 border-slate-600" },
};
